import {createBrowserHistory} from 'history';

export const historyMP= createBrowserHistory();